<template>
  <!-- Sidebar -->

  <!-- Sidebar - Brand -->
  <ul :class="classes">
    <router-link
      class="sidebar-brand d-flex align-items-center justify-content-center"
      to="/"
    >
      <div class="sidebar-brand-icon">
        <img src="/img/icons/logo.png" style="max-width:45px;" />
      </div>
      <div class="sidebar-brand-text mx-3">Admin</div>
    </router-link>

    <!-- Divider -->
    <hr class="sidebar-divider my-0" />

    <!-- Nav Item - Sequence -->

    <div v-for="navGroup in routers" :key="navGroup[0]">
      <hr class="sidebar-divider" />
      <div class="sidebar-heading">{{ navGroup[0] }}</div>

      <li class="nav-item" v-for="navItem in navGroup[1]" :key="navItem.name">
        <router-link class="nav-link" :to="navItem.path">
          <i>
            <font-awesome-icon :icon="navItem.meta.icon" />
          </i>
          <span>{{ navItem.name }}</span>
        </router-link>
      </li>
    </div>
  </ul>
  <!-- End of Sidebar -->
</template>

<script>
import router from "@/router";
import { AuthenticationContext } from "@/auth/msal-context";

export default {
  name: "MainSidebar",
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return this.collapsed
        ? "navbar-nav bg-gradient-primary accordion sidebar-dark sidebar toggled"
        : "navbar-nav bg-gradient-primary accordion sidebar-dark sidebar";
    },
    routes() {
      return router.options.routes;
    },
    routers() {
      let map = new Map();
      map.set("empty", []);
      this.routes.forEach((element) => {
        let group = "empty";
        if (element.meta.requireRoles === undefined || AuthenticationContext.checkRoles(element.meta.requireRoles)) {
          if (element.meta["group"] !== undefined) {
            group = element.meta.group;
          }
          if (!map.has(group)) {
            map.set(group, []);
          }
          map.get(group).push(element);
        }else{
          //console.log("Not allowed")
        }
      });
      return Array.from(map);
    },
  },
};
</script>
<style scoped></style>
